module.exports = __webpack_public_path__ + "static/project.761e8aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/project.png
// module id = 2738
// module chunks = 111930841657428